/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import bindMethods from 'auto-bind';

import Checkbox from '@mui/material/Checkbox';
import { VaultButton } from '../../../Shared';
import {
  selectIsAnySelected, playSelectedClips, stopSelectedClips, selectIsInit,
} from '../../state/clipList';
import { updateSelectAll } from '../../state/buttons';

const TitleContainer = styled.div`
  height: 40px;
  width: 50%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  flex-direction: row;
  margin-left: 4px;
`;

class ClipListTitle extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    const {
      updateSelectAll,
    } = this.props;
    updateSelectAll(false);
  }

  toggleSelectAll() {
    const {
      selectAll,
      clipList,
      updateSelectAll,
    } = this.props;
    if (clipList.length > 0) updateSelectAll(!selectAll);
  }

  render() {
    const {
      currentPlayingClip: { index },
      selectAll,
      isAnySelected,
      playSelectedClips,
      stopSelectedClips,
    } = this.props;
    const isPlaying = index !== null;

    return (
      <TitleContainer id="ClipListTitle">
        <Checkbox
          color="secondary"
          onChange={(e) => this.toggleSelectAll()}
          checked={selectAll}
        />
        {isPlaying ? (
          <VaultButton
            id="PauseAllButton"
            variant="plainOnPaper"
            onClick={stopSelectedClips}
            width="auto"
          >
            Stop
          </VaultButton>
        ) : (
          <VaultButton
            id="PlayAllButton"
            variant="plainOnPaper"
            onClick={playSelectedClips}
            width="auto"
            disabled={!isAnySelected}
          >
            Play Selected
          </VaultButton>
        )}
      </TitleContainer>
    );
  }
}

ClipListTitle.propTypes = {
  clipList: PropTypes.array.isRequired, // supplied from Redux
  currentPlayingClip: PropTypes.object.isRequired, // supplied from Redux
  selectAll: PropTypes.bool.isRequired, // supplied from Redux
  updateSelectAll: PropTypes.func.isRequired, // supplied from Redux
  playSelectedClips: PropTypes.func.isRequired, // supplied from Redux
  stopSelectedClips: PropTypes.func.isRequired, // supplied from Redux
  isAnySelected: PropTypes.bool.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  clipList: selectIsInit(state) ? state.clipList.allClips : [],
  currentPlayingClip: state.currentPlayingClip,
  selectAll: state.clipperButtons.selectAll,
  isAnySelected: selectIsAnySelected(state),
});

const mapDispatchToProps = {
  updateSelectAll,
  playSelectedClips,
  stopSelectedClips,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClipListTitle);
